import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import { QuestionnaireAction } from "../../store/actions";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
  datepicker,
  Loader,
} from "../../components";
import { UtilityArrays, Utils } from "../../config";

import "./styles.css";

const GeneralInfo = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);
  const { questionnaire, isLoading } = useSelector(
    (state) => state?.questionnaire
  );

  const [state, setState] = useState({
    middleName: "",
    dateOfBirth: "",
    citizenships: [],
  });

  useEffect(() => {
    dispatch(QuestionnaireAction.getQuestionnaire());
  }, []);

  useEffect(() => {
    setState({
      middleName: questionnaire?.middleName ?? "",
      dateOfBirth: questionnaire?.dateOfBirth ?? null,
      citizenships: questionnaire?.citizenships ?? [],
    });
  }, [questionnaire]);

  const handleNext = () => {
    if (!state.dateOfBirth || state.citizenships?.length === 0) {
      message.error("Please fill all the fields.");
    } else {
      const payload = { userId: profileData?.id, ...state };

      dispatch(
        QuestionnaireAction.addQuestionnaire(payload, (res) => {
          if (res.status === 200) {
            dispatch(
              QuestionnaireAction.getQuestionnaire(() =>
                navigate("/profile-builder/address")
              )
            );
          }
        })
      );
    }
  };

  return (
    <div className="text-black">
      <div className="header-md pl-2">General Information</div>
      <Spacer height={10} />
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <boxContainer.LiteBoxContainer>
          <div className="grid grid-cols-2 gap-x-7 gap-y-6">
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="First Name"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                placeholder="Enter your first name"
                value={profileData?.firstName}
                disabled
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel text="Middle Name" />
              <Spacer height={5} />
              <inputFields.DefaultInput
                onChange={(e) =>
                  setState({ ...state, middleName: e.target.value })
                }
                placeholder="Enter your middle name"
                value={state?.middleName}
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Last Name"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                placeholder="Enter your last name"
                value={profileData?.lastName}
                disabled
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Primary Email"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                placeholder="Enter your primary email"
                value={profileData?.email}
                type="email"
                disabled
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Phone Number"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultPhoneInput
                placeholder="Enter your phone number"
                value={profileData?.phoneNumber}
                disabled
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Date of Birth"
                required
              />
              <Spacer height={5} />
              <datepicker.DefaultDatepicker
                onChange={(date, dateString) => {
                  setState({ ...state, dateOfBirth: dateString });
                }}
                placeholder="--/--/----"
                datevalue={state?.dateOfBirth ?? null}
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Gender"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                placeholder="Enter your gender"
                value={profileData?.student?.gender}
                disabled
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Citizenship(s)"
                required
              />
              <Spacer height={5} />
              <inputFields.SelectDropdownMultiple
                onChange={(e) => {
                  if (e.length <= 2) {
                    setState({ ...state, citizenships: e });
                  }
                }}
                placeholder="Please select your nationality"
                value={state?.citizenships}
                items={Utils.filterArray(UtilityArrays.nationalities)}
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="LinkedIn"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                placeholder="Enter your liknedIn url"
                value={profileData?.student?.linkedIn}
                disabled
              />
            </div>
          </div>
          <Spacer height={20} />
          <div className="flex justify-end">
            <div className="w-[12.5em]">
              <Buttons.DefaultButton
                onClick={handleNext}
                size="large"
                width="full"
              >
                Next
              </Buttons.DefaultButton>
            </div>
          </div>
        </boxContainer.LiteBoxContainer>
      )}
    </div>
  );
};

export default GeneralInfo;
